import { render, staticRenderFns } from "./QuotePolicyDetail.vue?vue&type=template&id=9bec3dda&"
import script from "./QuotePolicyDetail.vue?vue&type=script&lang=js&"
export * from "./QuotePolicyDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuotePolicyDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/QuotePolicyDetail.vue
// module id = null
// module chunks = 